import * as t from 'io-ts';
import UserProfileContacts, { UserProfileContactsType } from './userProfileContacts';
import UserProfilePersonality, { UserProfilePersonalityType } from './userProfilePersonality';

export const UserProfileType = t.interface({
    id: t.string,
    userId: t.union([t.string, t.null, t.undefined]),
    updateDate: t.union([t.string, t.null, t.undefined]),
    contacts: t.union([UserProfileContactsType, t.null]),
    personality: t.union([UserProfilePersonalityType, t.null]),
    takId: t.union([t.string, t.null, t.undefined]),
    misId: t.union([t.string, t.null, t.undefined]),
    syncNewResults: t.boolean,
});

export interface UserProfileDto extends t.TypeOf<typeof UserProfileType> {
}

class UserProfile {
    id: string;
    userId: string | null;
    updateDate: string | null;
    contacts: UserProfileContacts | null;
    personality: UserProfilePersonality | null;
    takId: string | null;
    misId: string | null;
    syncNewResults: boolean;

    constructor(params: UserProfileDto) {
        this.id  = params.id;
        this.userId = params.userId ?? null;
        this.updateDate = params.updateDate ?? null;
        this.contacts = !!params.contacts
            ? new UserProfileContacts(params.contacts)
            : null;
        this.personality = !!params.personality
            ? new UserProfilePersonality(params.personality)
            : null;
        this.takId = params.takId ?? null;
        this.misId = params.misId ?? null;
        this.syncNewResults = params.syncNewResults;
    }
}

export default UserProfile;
